import { CommonKeys } from "../../../common/enums";
import type { StammElement } from "./StammElement";

export const STAMM_BELEG_TYPE = "AM_Services.Domain.Models.Formulare.StammElementBeleg, AM_Services.Domain.Standard";

export const FormularGroupStammStammElementBelegSchema = {
    $id: "FormularGroupStammStammElementBelegSchema",
    title: "FormularGroupStammStammElementBeleg Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_BELEG_TYPE },
                Property: { type: "number", nullable: true }
            }
        }
    ],
};

export interface StammElementBeleg extends StammElement {
    Property: StammElementBelegProperty
}

export enum StammElementBelegProperty {
    SammelNr, Kennwort, Belegdatum, BelegNr, IhreBestellung, IhrZeichen, UnserZeichen,
    AdresseNr,
    AdresseEinzeilig,
    AdressePostanschrift,
    AdresseRechnungEinzeilig,
    AdresseRechnungPostanschrift,
    AdresseLieferanschriftEinzeilig,
    AdresseLieferanschriftPostanschrift,
    CustomerName, CustomerName2, CustomerName3, CustomerName4, CustomerStreet, CustomerPostalCodeCity,
}